var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"banner-wrapper"},[_vm._t("content")],2),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }